<form [formGroup]="form" class="app-modal-form">
  <div class="modal-topbar">
    <h5 class="modal-title" translate>ATTACHMENTS.ADD</h5>
    <div class="modal-actions">
      <button pButton type="button" icon="pi pi-window-maximize"
              class="p-button-text p-button-rounded p-button-plain"
              onclick="const d=this.closest('.p-dialog'); if(d){d.classList.toggle('app-dialog-maximized');}"></button>
      <button pButton type="button" icon="pi pi-times"
              class="p-button-text p-button-rounded p-button-plain"
              (click)="ref.close()"></button>
    </div>
  </div>
  <div class="p-fluid formgrid grid">
    <div class="field col-12 md:col-6">
      <label for="fileName" translate>ATTACHMENTS.FILE_NAME</label>
      <input id="fileName" type="text" pInputText formControlName="fileName">
    </div>
  </div>
</form>
<p-footer>
  <p-fileUpload name="file"
                [chooseLabel]="'ATTACHMENTS.ADD' | translate"
                (onSelect)="onFileSelect($event)"
                mode="basic"
                [auto]="true"
                maxFileSize="10000000"
                class="mb-3">
  </p-fileUpload>
</p-footer>
